import { IThemeProps } from "component/theme";
import styled from "styled-components";
import Box from "../Box/Box";
import { SECONDARY_MENU_HEIGHT, TOP_NAV_HEIGHT, TOP_NAV_MOBILE_HEIGHT } from "../topNav/topNav.style";

export const StyledIndicator = styled(Box)`
${({ theme, isHidePrimaryTopNav }: IThemeProps & { isHidePrimaryTopNav: boolean}) => `
  position: fixed;
  top: ${isHidePrimaryTopNav ? 0 : TOP_NAV_MOBILE_HEIGHT}px;
  left: 0;
  right: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  width: 100vw;

  @media (min-width: ${theme.breakpoints.md}) {
    top: ${isHidePrimaryTopNav ? 0 : TOP_NAV_HEIGHT}px;
  }

  @media (min-width: ${theme.breakpoints.lg}) {
    top: ${isHidePrimaryTopNav ? 0 : (TOP_NAV_HEIGHT + SECONDARY_MENU_HEIGHT)}px;
  }
`}`;

export const StyledBoxIndicator = styled(Box)`
  ${({ theme }: IThemeProps) => `
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    min-height: 48px;
    background-color: ${theme.uptimeColors.mainTheme.light};
    box-shadow: 0px 4px 0px ${theme.uptimeColors.mainTheme.primary};

    .indicator-title {
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
      font-weight: bold;
      line-height: ${theme.uptimeLineHeights.desktop.lh5}px;
      color: ${theme.uptimeColors.textColors.primary};
      text-align: center;
      work-break: break-word;
    }
  `}
`;